import React, { useContext, useState } from 'react';

import { ActivateSubscriptionDialog } from '@vyce/core/src/components';
import { Invites } from '@vyce/core/src/modules';
import {
  fetchInviteFilterInviters,
  fetchInviteFilterResources,
} from '@vyce/core/src/modules/invitesModule/utils';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { MANAGEMENT_PERMISSIONS } from '@vyce/core/src/types';

import { useTypedSelector, useInviteButton } from 'src/hooks';
import { UniversalInviteModule } from 'src/modules';
import { InvitesContext } from 'src/store/invites-context';

export const EmployerInviteList: React.FC = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const { getInvites, resendInvite, deleteInvite, retryInviteItem } = useContext(InvitesContext);
  const { can } = usePermissions();
  // The staff list behind "Invited by" takes its own right — don't ask for a guaranteed 403
  const canListStaff = can(MANAGEMENT_PERMISSIONS.LIST_STAFF);

  const [invitesReloadKey, setInvitesReloadKey] = useState(0);

  const {
    isInviteFormOpen,
    subscribeLoading,
    isActivateSubscriptionDialogOpen,
    simpleSubscribe,
    setCloseInviteForm,
    handleInviteButtonClick,
    closeActivateSubscriptionDialog,
  } = useInviteButton();

  return (
    <>
      <Invites
        selectedCompanyId={selectedCompany?.uuid}
        handleInviteButtonClick={handleInviteButtonClick}
        deleteInviteRequest={deleteInvite}
        getInvitesRequest={getInvites}
        resendInviteRequest={resendInvite}
        retryInviteItemRequest={retryInviteItem}
        fetchFilterResources={fetchInviteFilterResources}
        fetchFilterInviters={canListStaff ? fetchInviteFilterInviters : undefined}
        reloadKey={invitesReloadKey}
      />
      <UniversalInviteModule
        isOpen={isInviteFormOpen}
        onClose={setCloseInviteForm}
        onSuccess={() => setInvitesReloadKey(value => value + 1)}
      />
      <ActivateSubscriptionDialog
        open={isActivateSubscriptionDialogOpen}
        onClose={closeActivateSubscriptionDialog}
        callback={simpleSubscribe}
        loading={subscribeLoading}
        wasSubscribed={selectedCompany?.subscribed_company}
      />
    </>
  );
};
